<template>
  <div class="wrapper">
    <div class="main ">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">
                {{ $t("travail.titre-programme") }}
              </h2>
              <h5 class="description">
                {{ $t("travail.sous") }}
              </h5>
            </div>
          </div>

          <div class="features text-center">
            <div class="md-layout">
              <div
                class="md-layout-item md-medium-size-33 md-small-size-100 bg-info image"
                :style="headerStyle"
              ></div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <h4 class="info-title">
                    {{ $t("travail.programme1.titre") }}
                  </h4>
                  <p>
                    {{ $t("travail.programme1.description") }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="features text-center">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <h4 class="info-title">
                    {{ $t("travail.programme2.titre") }}
                  </h4>
                  <p>
                    {{ $t("travail.programme2.description") }}
                  </p>
                </div>
              </div>
              <div
                class="md-layout-item md-medium-size-33 md-small-size-100 image"
                :style="headerStyle1"
              ></div>
            </div>
          </div>

          <div class="features text-center">
            <div class="md-layout">
              <div
                class="md-layout-item md-medium-size-33 md-small-size-100 bg-info image"
                :style="headerStyle2"
              ></div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <h4 class="info-title">
                    {{ $t("travail.programme3.titre") }}
                  </h4>
                  <p>
                    {{ $t("travail.programme3.description") }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="features text-center">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <h4 class="info-title">
                    {{ $t("travail.programme4.titre") }}
                  </h4>
                  <p>
                    {{ $t("travail.programme4.description") }}
                  </p>
                </div>
              </div>
              <div
                class="md-layout-item md-medium-size-33 md-small-size-100 image"
                :style="headerStyle3"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h2 class="title text-center">
      <md-button class="md-success md-lg text-center" @click="goto">
        {{$t("travail.autre")}}
      </md-button>
    </h2>
  </div>
</template>

<script>
export default {
  bodyClass: "programme",
  props: {
    admission: {
      type: String,
      default: require("@/assets/img/chantier.jpeg")
    },
    garant: {
      type: String,
      default: require("@/assets/img/qualifier.jpg")
    },
    permis: {
      type: String,
      default: require("@/assets/img/province.jpeg")
    },
    visa: {
      type: String,
      default: require("@/assets/img/investisseur.jpeg")
    },
    logement: {
      type: String,
      default: require("@/assets/img/investisseur.jpeg")
    },
    billet: {
      type: String,
      default: require("@/assets/img/billet.jpeg")
    },
    voyage: {
      type: String,
      default: require("@/assets/img/voyage.jpeg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.admission})`
      };
    },
    headerStyle1() {
      return {
        backgroundImage: `url(${this.garant})`
      };
    },
    headerStyle2() {
      return {
        backgroundImage: `url(${this.permis})`
      };
    },
    headerStyle3() {
      return {
        backgroundImage: `url(${this.logement})`
      };
    },
    headerStyle4() {
      return {
        backgroundImage: `url(${this.visa})`
      };
    },
    headerStyle5() {
      return {
        backgroundImage: `url(${this.billet})`
      };
    },
    headerStyle6() {
      return {
        backgroundImage: `url(${this.voyage})`
      };
    }
  },

  methods: {
    goto() {
      this.$router.push({ path: '/procedure', query: { type: 'affaire' } })
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}
.md-layout-item {
  // background-color: #00c853;
}
.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
